module.exports = __webpack_public_path__ + "static/media/Artboard29.77986ad2.png";